import { Head, Link, useForm } from "@inertiajs/react"

import imperativeIcon from "@/assets/imperative_icon.svg"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Checkbox } from "@/components/ui/checkbox"
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import AuthLayout from "@/layouts/auth-layout"
import { cn } from "@/lib/utils"
import { newPartnerUserPasswordPath } from "@/routes"

export default function PartnerLogin() {
  const { data, setData, post, processing, errors } = useForm({
    partner_user: {
      email: "",
      password: "",
      remember_me: false as boolean,
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/partner_users/sign_in")
  }

  return (
    <AuthLayout title="" description="">
      <Head title="Partner Login" />
      <div className={cn("flex w-full flex-col gap-6")}>
        <Card className="rounded-lg shadow-md">
          <CardHeader className="items-center text-center">
            <img
              src={imperativeIcon}
              alt="Imperative"
              className="mx-auto size-12 rounded-xl"
            />
            <CardTitle className="pt-2 text-xl tracking-tight">
              Sign in to Imperative
            </CardTitle>
            <CardDescription>
              Welcome back! Please sign in to continue.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <FieldGroup>
                <Field>
                  <FieldLabel htmlFor="email">Email</FieldLabel>
                  <Input
                    id="email"
                    type="email"
                    name="partner_user[email]"
                    placeholder="you@company.com"
                    value={data.partner_user.email}
                    onChange={(e) =>
                      setData("partner_user", {
                        ...data.partner_user,
                        email: e.target.value,
                      })
                    }
                    required
                    autoFocus
                  />
                  {errors["partner_user.email"] && (
                    <FieldError>{errors["partner_user.email"]}</FieldError>
                  )}
                </Field>
                <Field>
                  <div className="flex items-center">
                    <FieldLabel htmlFor="password">Password</FieldLabel>
                    <Link
                      href={newPartnerUserPasswordPath()}
                      className="ml-auto text-sm underline-offset-4 hover:underline"
                    >
                      Forgot your password?
                    </Link>
                  </div>
                  <Input
                    id="password"
                    type="password"
                    name="partner_user[password]"
                    value={data.partner_user.password}
                    onChange={(e) =>
                      setData("partner_user", {
                        ...data.partner_user,
                        password: e.target.value,
                      })
                    }
                    required
                  />
                  {errors["partner_user.password"] && (
                    <FieldError>{errors["partner_user.password"]}</FieldError>
                  )}
                </Field>
                <Field orientation="horizontal">
                  <Checkbox
                    id="remember_me"
                    name="partner_user[remember_me]"
                    checked={data.partner_user.remember_me}
                    onCheckedChange={(checked) =>
                      setData("partner_user", {
                        ...data.partner_user,
                        remember_me: checked as boolean,
                      })
                    }
                  />
                  <FieldLabel htmlFor="remember_me" className="cursor-pointer">
                    Remember me
                  </FieldLabel>
                </Field>
                <Field>
                  <Button type="submit" className="w-full" loading={processing}>
                    {processing ? "Signing in..." : "Sign in"}
                  </Button>
                </Field>
              </FieldGroup>
            </form>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
